module.exports = __webpack_public_path__ + "media/images/admin/icons/navigation-729ba1adbf47b6533fd6191214769dd2.svg";